import { handleChunkLoadError } from '@hydra/utils/handleChunkLoadError';

export default ({
  path: 'fb/:callback',
  async getComponent (nextState) {
    const {
      default: FbContainer
    } = await import(/* webpackChunkName: "fb" */ './containers/FbContainer.jsx')
      .catch(handleChunkLoadError);
    return FbContainer;
  }
});
